import { Link } from "react-router-dom";
// @mui
import { Container, Typography, Box, Stack } from "@mui/material";
// components
import { Logo } from "./index";

// ----------------------------------------------------------------------

const info = [
	{ label: "대표", text: "정수한" },
	{ label: "사업자등록번호", text: "766-87-00891" },
	{
		label: "통신판매업 신고번호",
		text: "제 2017-서울마포-2244호",
	},
	{
		label: "주소 Head Office",
		text: "대전광역시 유성구 유성대로 773, 2층 201-가호 필로스페이스 비지니스 센터 에이치실 5호",
	},
	{
		label: "Seoul Office",
		text: "서울특별시 마포구 독막로9길 18 2F",
	},
	{ label: "이메일", text: "info@queenssmile.co.kr" },
	{ label: "전화번호", text: "070-7734-7796" },
];

export default function FooterSimple({ fixed }) {
	return (
		<Box
			sx={{
				bgcolor: "grey.900",
				py: 3,
				position: fixed ? "fixed" : "unset",
				bottom: 0,
				left: 0,
				width: "100%",
			}}
		>
			<Container sx={{ my: 3 }}>
				<Stack
					direction="row"
					justifyContent="space-between"
					alignItems="flex-end"
				>
					{/* left */}
					<Box>
						<Box sx={{ width: 200, mb: 3 }}>
							<Logo white />
						</Box>
						<Stack direction="row" sx={{ flexWrap: "wrap", width: "130%" }}>
							<Typography variant="body2" sx={{ color: "white" }}>
								주식회사 퀸즈스마일
							</Typography>
							{info.map((item, i) => (
								<Typography key={i} variant="body2" sx={{ color: "white" }}>
									{i === 3 || i === 5 ? null : (
										<Box
											component="span"
											sx={{
												color: "grey.100",
												px: 1,
											}}
										>
											|
										</Box>
									)}

									{item.label}
									<Box
										component="span"
										sx={{
											color: "grey.300",
										}}
									>
										&nbsp;{item.text}
									</Box>
								</Typography>
							))}
						</Stack>
					</Box>

					<Box sx={{ display: "flex" }}></Box>
					<Typography
						variant="body2"
						color={"white"}
						sx={{ width: "100%", textAlign: "right" }}
					>
						<Link
							style={{ textDecoration: "none", color: "white" }}
							to="https://app.catchsecu.com/document/P/8f664b4e439c4d5"
							target="_black"
						>
							개인정보처리방침
						</Link>
						<Box
							component="span"
							sx={{
								color: "grey.100",
								px: 1,
							}}
						>
							|
						</Box>
						<Link
							style={{ textDecoration: "none", color: "white" }}
							to="https://queenssmile.co.kr/mypage/setting/terms/service"
							target="_black"
						>
							서비스이용약관
						</Link>
						<Box
							component="span"
							sx={{
								color: "grey.100",
								px: 1,
							}}
						>
							|
						</Box>
						<Link
							style={{ textDecoration: "none", color: "white" }}
							to="/shuttle-privacy"
						>
							셔틀버스앱이용약관
						</Link>
					</Typography>
				</Stack>
			</Container>
		</Box>
	);
}
